import { EdgeIcon } from "../assets";
import { Particles } from "./particles";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { version } from "../../../../../../package.json";
import React, { useEffect } from "react";

type AuthLayoutProps = {
  children: React.ReactNode;
};

export const AuthLayout = ({
  children,
}: AuthLayoutProps): React.ReactElement => {
  const [t] = useTranslation("global");
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.clear();
  }, [queryClient]);

  return (
    <div className="h-screen w-screen overflow-hidden bg-black">
      <Particles className="fixed h-screen w-screen" />
      <div className="absolute flex h-screen w-screen flex-col justify-between overflow-hidden  px-6 py-10 lg:px-20 ">
        <h1 className="w-40 text-2xl font-medium text-white md:w-full md:pt-[10vh] md:text-center md:text-3.5xl xl:pt-0 xl:text-left xl:text-4xl ">
          {t("context.shared.components.auth-layout.header")}
        </h1>
        <div className="w-full">{children}</div>
        <footer>
          <div className="flex w-full justify-center xl:justify-start">
            <EdgeIcon className="w-[72px] md:w-28  xl:w-[141px]" />
          </div>
          <p className="col-span-2 hidden text-center text-white xl:block">
            {t("context.shared.components.auth-layout.footer.version")}
            {version}
          </p>
        </footer>
      </div>
    </div>
  );
};
